import { encryptObject } from "@/helpers/noncehelper";
import {
  addFavourites,
  fetchFavourites,
  removeFavourites,
  setPreferencesToSpoonguru,
} from "@/services/spoonguru";
import { fetchSafeJson } from "@/utils/apiResponse";
import { createAsyncThunk } from "@reduxjs/toolkit";
export const getfetchFavouritesRecipes = createAsyncThunk(
  "/favourites",
  async (payload: any) => {
    const res = await fetchFavourites(encryptObject({ token: payload?.token }));
    const data: any = await fetchSafeJson(res);
    return data?.response;
  }
);

export const addFavouritesRecipes = createAsyncThunk(
  "add/favourites",
  async (payload: any) => {
    const res = await addFavourites(encryptObject(payload));
    return res;
  }
);
export const removeFavouritesRecipes = createAsyncThunk(
  "remove/favourites",
  async (payload: any) => {
    const res = await removeFavourites("/favourites", payload);
    return res;
  }
);

export const setPreferences = createAsyncThunk(
  "/preferences",
  async (payload: any) => {
    const res = await setPreferencesToSpoonguru("/preferences", payload);
    return res;
  }
);
